module.exports = __webpack_public_path__ + "img/head-mv04.b3a53032.jpg";